import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDatepickerModule } from '@angular/material';

import { NotificationService } from '../shared/services/notification.service';

import { OfferExpectation } from '../shared/interfaces/offer.interface';

import { OfferModalComponent } from '../shared/components/offer-modal/offer-modal.component';
import { PromotionModalComponent } from '../shared/components/promotion-modal/promotion-modal.component';


@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	offerExpectationForm: FormGroup;
	currentDate = new Date();

	constructor(
		private formBuilder: FormBuilder,
		private notificationService: NotificationService
	) {
		this.offerExpectationForm = this.formBuilder.group({
			arrival: [null, Validators.required],
			departure: [null, Validators.required],
			adult: [null, Validators.required],
			child: [null],
			baby: [null]
		});
	}

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts